import React from "react";
import { Brand, Button, Container, Content, Copyright, Description, Divider, SocialLink, Socials, Subtitle, Title, TitleFooter, Top } from "./styles";
import { FaFacebook, FaInstagram, FaTiktok } from "react-icons/fa";
import { PhoneCall } from "lucide-react";

const Footer = () => {
    return (
        <Container id="contact">
            <Top>
                <Brand>
                    <Title>
                        ¿Listo para transformar tu negocio?
                    </Title>

                    <Description>
                        Hablemos sobre tu proyecto y descubre cómo podemos
                        desarrollar una solución digital adaptada a tus necesidades.
                    </Description>
                </Brand>

                <Button
                    href="https://wa.me/5213316710897/?text=Hola,%20me%20interesa%20conocer%20los%20servicios%20de%20NanoCode%20y%20me%20gustar%C3%ADa%20cotizar%20una%20soluci%C3%B3n%20para%20mi%20negocio.%20%C2%BFPodr%C3%ADan%20brindarme%20m%C3%A1s%20informaci%C3%B3n%3F"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <PhoneCall size={18}/>
                    Contactar
                </Button>
            </Top>

            <Divider />

            <Content>
                <div>
                    <TitleFooter>NanoCode</TitleFooter>

                    <Copyright>
                        © 2026 NanoCode.
                        <br />
                        Todos los derechos reservados.
                    </Copyright>
                </div>

                <div>
                    <Subtitle>Síguenos</Subtitle>

                    <Socials>
                        <SocialLink
                            href="https://www.instagram.com/nano_code._?igsh=MXNuOGVpZzN3ZXFvMw=="
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                        >
                            <FaInstagram size={22}/>
                        </SocialLink>

                        <SocialLink
                            href="https://www.facebook.com/share/19EhMWF9MV/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Facebook"
                        >
                            <FaFacebook size={22}/>
                        </SocialLink>

                        <SocialLink
                            href="https://www.tiktok.com/@nanocode15?_r=1&_t=ZS-98RaKU3HuQ1"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="TikTok"
                        >
                            <FaTiktok size={22}/>
                        </SocialLink>
                    </Socials>
                </div>
            </Content>
        </Container>
    )
};

export default Footer;